<template>
<v-card>
  <v-card-title class='overline py-1 grey lighten-4' >
    <v-btn icon small @click="validate" :loading="req.validate.loading" >
      <v-icon small >mdi-refresh</v-icon>
    </v-btn>
    <v-divider vertical class="mr-1" />
    Are you sure you want to deactivate
    {{ practitioner.user.first_name }} {{ practitioner.user.last_name }}
    <v-spacer/>
    <v-btn small icon @click="$emit('close')" >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-card-title>
  <v-divider/>
  <request-status :request="req.validate" />
  <request-status
    :request="req.save"
    @ok="$emit('saved', practitioner);$emit('close')" />
  <template v-if="req.validate.status === 200" >
    <v-alert tile type="error" v-if="errors && errors.length > 0" >
      <ul>
        <li v-for="error in errors" :key="error" v-text="error" />
      </ul>
    </v-alert>
    <v-row v-else >
      <v-col cols="6" >
        <v-card flat height="100%" >
          <v-card-title >
            What happens when a member is deactivated
          </v-card-title>
          <ul class="ml-2" >
            <li>All memberships will be archived</li>
            <li>Their email, phone number and password will be cleared so they can no longer log in</li>
            <li>Email redirects will be cleared</li>
            <li>If they have a personal website it will be disabled</li>
            <li>Your billing will be adjusted to exclude this member on your next billing cycle</li>
          </ul>
          <v-checkbox
            class="ml-2"
            label="Got it. I confirm that I want to deactivate this user" />
        </v-card>
      </v-col>
      <v-col cols="6" >
        <v-card class="grey lighten-4 mr-3 elevation-10" >
          <v-card-title class="overline py-1" >
            Deactivation Summary
          </v-card-title>
          <v-card-text>

            <v-list dense subheader class="elevation-3 pb-0" >
              <v-subheader class="overline ml-1">The following seats will be deactivated</v-subheader>
              <v-list-item v-for="seat in seats" :key="seat.id" >
                <v-list-item-content>
                  <v-list-item-title >
                    {{user.first_name}} {{user.last_name}}
                    <v-chip x-small label outlined
                      v-if="seat && seat.package"
                      class="mr-2" >{{ seat.package_name}}</v-chip>
                    <v-chip x-small label outlined v-if="seat.role" >{{ seat.role.title}}</v-chip>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action >
                  {{ formatCurrency(currency, seat.calculated_seat_price) }}
                </v-list-item-action>
              </v-list-item>
              <v-list-item v-if="seats && seats.length === 0" >
                <v-list-item-content><v-list-item-title >No active seats found</v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-alert text tile
                class="py-2 caption"
                type="info" border="left" >
                Price changes will apply on your next billing cycle
              </v-alert>
            </v-list>

            <v-list dense subheader class="elevation-3 mt-3" >
              <v-subheader class="overline ml-1">The following memberships will be archived</v-subheader>
              <v-list-item v-for="membership in memberships" :key="membership.id" >
                <v-list-item-content>
                  <v-list-item-title >
                    {{ membership.role}} at {{ membership.space_name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="memberships && memberships.length === 0" >
                <v-list-item-content><v-list-item-title >No active memberships found</v-list-item-title></v-list-item-content>
              </v-list-item>
            </v-list>

            <v-subheader class="overline">Appointments</v-subheader>
            <ul v-if="counts" class="ml-2" >
              <li >Past appointments: {{counts.past_appts}}</li>
              <li >Future appointments: {{counts.future_appts}}</li>
              <li >Total appointments: {{counts.appointments}}</li>
            </ul>
            <!-- <template v-if="counts.appointments > 0" >
              <v-switch small
                v-model="transfer"
                class="ml-2"
                label="Would you like to transfer appointments to a different practitioner?" />

              <v-card v-if="transfer" outlined class="grey lighten-4 elevation-10" >
                <transfer-appointments :member="member" @close="transfer=false" />
              </v-card>
            </template> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </template>

  <v-divider class="mt-3" />
  <v-card-actions class="grey lighten-4" >
    <v-btn text @click="$emit('close')" >Cancel</v-btn>
    <v-spacer />
    <v-btn
      @click="save"
      color="primary"
      :disabled="!canArchive"
      :loading="req.loading" >Deactivate member</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
// import TransferAppointments from "./TransferAppointments.vue"
export default {
  name: 'RemoveMember',
  // components: {TransferAppointments},
  props: {
    title: { type: String },
    practitioner: { required: true }
  },
  data () {
    return {
      transfer: false,
      req: {
        validate: {
          resource: 'ag.team',
          extra: 'archive_member',
          method: 'get'
        },
        save: {
          resource: 'ag.team',
          extra: 'archive_member',
          method: 'post'
        }
      }
    }
  },
  mounted () {
    this.validate()
  },
  watch: {
    practitionerId () {
      this.validate()
    }
  },
  computed: {
    practitionerId () {
      return this.getObjectPath(this.practitioner, 'user.id')
    },
    remotePractitioner () {
      return this.getObjectPath(this.req, 'validate.result.summary.practitioner', {})
    },
    user () {
      return this.getObjectPath(this.remotePractitioner, 'user', {})
    },
    memberships () {
      return this.getObjectPath(this.req, 'validate.result.summary.memberships', [])
    },
    seats () {
      return this.getObjectPath(this.req, 'validate.result.summary.seats', [])
    },
    summary  () {
      return this.getObjectPath(this.req, 'validate.result.summary', {})
    },
    counts  () {
      return this.getObjectPath(this.req, 'validate.result.summary.counts', {})
    },
    errors () {
      return this.getObjectPath(this.req, 'validate.result.errors.actor', [])
    },
    canArchive () {
      return (this.req.validate.loading === false && this.errors.length === 0)
    }
  },
  methods: {
    validate () {
      this.req.validate.params = {
        practitioner: this.practitionerId,
        business: this.calculatedBusinessId
      }
      this.$request('get', this.req.validate)
    },
    save () {
      this.req.save.data = {
        practitioner: this.practitionerId,
        business: this.calculatedBusinessId
      }
      this.$request('save', this.req.save)
    }
  }
}
</script>
